<!--
   Created by qing on 2020/12/18
   Des: 
-->
<template>

  <van-popup
    class="node-list-popup"
    v-model="visibleInfo.visible"
    :overlay="false"
    get-container="body"
    safe-area-inset-bottom
    :style="{ height: '100%', width: '100%' }"
    @close="beforeClose"
    position="right">
    <template v-if="loadingEnd">

      <div class="header">
        <i class="iconfont icon-cengji1"></i>
        <div class="info">
          <div class="name">
            {{node.nodeName}}
          </div>
          <div class="detail" v-if="node.handlePermission">
            <div @click="onClickNodeDetail">
              详情
            </div>
            <div @click="onClickEditNode">
              编辑
            </div>
            <div class="delete-button" @click="onClickDeleteNode">
              删除
            </div>
          </div>
        </div>
        <van-icon v-if="node.handlePermission" name="add-o" @click="onClickAddItem"/>
      </div>
      <div class="content" v-if="(node.handlePermission && itemList.length) || nodeList.length">

        <template v-if="node.handlePermission">

          <div
            class="item"
            v-for="item in itemList"
            :key="item.itemId"
            @click.stop="onClickItem(item)">
            <img :src="item.itemImage" alt="">
            <div class="info">
              <div class="top">
                <div class="name">
                  {{item.itemDetail.name}}
                </div>
                <van-tag
                  v-if="item.itemDetail.status"
                  :type="stepStatusMap[item.itemDetail.status] ? stepStatusMap[item.itemDetail.status].color : ''"
                  plain>
                  {{stepStatusMap[item.itemDetail.status] ? stepStatusMap[item.itemDetail.status].name : ''}}
                </van-tag>
              </div>
              <div class="bottom">
                <div class="user" v-if="$store.getters.userListMap[item.userId]">
                  {{$store.getters.userListMap[item.userId]['nickname']}}
                </div>
                <div class="user" v-else-if="$store.getters.extMap[item.userId]">
                  {{$store.getters.extMap[item.userId]['orgUserName']}}
                </div>
                <div class="handle">
                  <el-button
                    type="text"
                    icon="el-icon-delete"
                    style="color: red"
                    @click.stop="deleteItem(item)"
                  ></el-button>
                  <el-button
                    v-if="false"
                    type="text"
                    icon="el-icon-edit"
                    @click.stop="editItem(item)"
                  ></el-button>
                </div>
              </div>
            </div>
          </div>
        </template>

        <div
          class="node-item"
          v-for="node in nodeList"
          :key="node.nodeId"
          @click="onClickNode(node)">
          <div class="color" :style="{backgroundColor: node.nodeColor}"></div>
          <div class="node-name">
            {{node.nodeName}}
          </div>
          <van-icon name="arrow"/>
        </div>
      </div>
	  <empty v-else style="height: calc(100% - 60px)"></empty>

    </template>

    <node-list-popup
      ref="nodeListPopup"
      :titleInfo="titleInfo"
      :stackList="stackList"
      :mixFormId="mixFormId"
      :mixFormInfo="mixFormInfo"
      :chargeUserConfig="chargeUserConfig"
      :participantConfig="participantConfig"
      @deleteNodeComplete="deleteNodeComplete"
      @close="nodeListPop"
    ></node-list-popup>

    <node-detail-popup
      ref="nodeDetailPopup"
      :stackList="stackList"
      :mixFormId="mixFormId"
      @close="nodeListPop"
    ></node-detail-popup>

    <!--附件、图片附件、备忘item详情-->
    <node-item-detail-popup
      ref="nodeItemDetailPopup"
      :titleInfo="titleInfo"
      :stackList="stackList"
      :mixFormId="mixFormId"
      :mixFormInfo="mixFormInfo"
      @updateItemComplete="updateItemComplete"
      @deleteNodeItemComplete="deleteNodeItemComplete"
      @close="nodeListPop"
    ></node-item-detail-popup>

    <!--申请表单详情-->
    <apply-form-detail
      ref="applyFormDetail"
      :stackList="stackList"
      :mixFormId="mixFormId"
      :mixFormInfo="mixFormInfo"
      @deleteNodeItemComplete="deleteNodeItemComplete"
      @close="nodeListPop"
    ></apply-form-detail>

    <!--添加、编辑下级目录-->
    <add-node-popup
      ref="nodeAddPopup"
      :mixFormId="mixFormId"
      :stackList="stackList"
      :chargeUserConfig="chargeUserConfig"
      :participantConfig="participantConfig"
      @updateNodeSuccess="updateNodeSuccess"
      @createNodeSuccess="createNodeSuccess"
      @close="nodeListPop"
    ></add-node-popup>

    <!--选择新建item-->
    <select-item-popup
      ref="selectItemPopup"
      :stackList="stackList"
      :mixFormId="mixFormId"
      @selectItem="selectCreateItem"
    ></select-item-popup>

    <!--新建备忘、附件、图片item-->
    <node-add-attach-popup
      ref="nodeAddAttachPopup"
      :stackList="stackList"
      :mixFormId="mixFormId"
      @createItemComplete="createItemComplete"
      @close="nodeListPop"
    ></node-add-attach-popup>

    <!--发起表单-->
    <apply-form-popup
      ref="applyFormPopup"
      @applySuccess="applyFormComplete"
    ></apply-form-popup>

    <!--处理表单弹窗-->
    <handle-form-popup
      ref="handleFormPopup"
      :chargeUserConfig="chargeUserConfig"
      :stackList="stackList"
      @handleComplete="handleComplete"
      @close="nodeListPop"
    ></handle-form-popup>

    <!--表单数据列表弹窗-->
    <form-data-view-popup
      ref="formDataViewPopup"
      :stackList="stackList"
      @close="nodeListPop"
    ></form-data-view-popup>

    <dashboard-popup
      ref="dashboardPopup"
      :stackList="stackList"
      @close="nodeListPop"
    ></dashboard-popup>
  </van-popup>
</template>

<script>
  import {
    MIX_FORM_ITEM_TYPE_APPLY,
    MIX_FORM_ITEM_TYPE_ATTACHMENT, MIX_FORM_ITEM_TYPE_DASHBOARD, MIX_FORM_ITEM_TYPE_DATA,
    MIX_FORM_ITEM_TYPE_IMAGE,
    MIX_FORM_ITEM_TYPE_MEMO, MIX_FORM_ITEM_TYPE_MIX_FORM, MIX_FORM_ITEM_TYPE_NODE, MIX_FORM_ITEM_TYPE_VIEW
  } from "../../store/types";
  import {FORM_VIEW_TYPE_BOARD_VIEW, FORM_VIEW_TYPE_DATA_HANDLE} from "../../../assets/types";
  import NodeDetailPopup from "./NodeDetailPopup";
  import NodeItemDetailPopup from "./NodeItemDetailPopup";
  import AddNodePopup from "./AddNodePopup";
  import SelectItemPopup from "./SelectItemPopup";
  import NodeAddAttachPopup from "./NodeAddAttachPopup";
  import ApplyFormPopup from "./ApplyFormPopup";
  import ApplyFormDetail from "./ApplyFormDetail";
  import {arrayRemove} from "../../../assets/js/Untis";
  import HandleFormPopup from "./HandleFormPopup";
  import FormDataViewPopup from "./FormDataViewPopup";
  import DashboardPopup from "./DashboardPopup";

  export default {
    props: {
      chargeUserConfig: Object,
      participantConfig: Object,
      titleInfo: Object,
      mixFormInfo: Object,
      mixFormId: {
        type: String,
        default: ''
      },
      stackList: {
        type: Array,
        default: () => []
      }
    },
    components: {
      HandleFormPopup,
      NodeDetailPopup,
      NodeItemDetailPopup,
      AddNodePopup,
      SelectItemPopup,
      NodeAddAttachPopup,
      ApplyFormPopup,
      ApplyFormDetail,
      FormDataViewPopup,
      DashboardPopup
    },
    data() {
      return {
        MIX_FORM_ITEM_TYPE_APPLY,
        visibleInfo: {
          nodeId: '',
          visible: false
        },
        itemList: [],
        nodeList: [],
        node: null,
        // 步骤状态map
        stepStatusMap: {
          INIT: {
            type: 'INIT',
            name: '发起',
            color: ''
          },
          NOT_START: {
            type: 'NOT_START',
            name: '未开始',
            color: 'primary'
          },
          RUNNING: {
            type: 'RUNNING',
            name: '进行中',
            color: 'warning'
          },
          FINISH: {
            type: 'FINISH',
            name: '完成',
            color: 'success'
          },
          REJECT: {
            type: 'REJECT',
            name: '拒绝',
            color: 'danger'
          },
          REPULSE: {
            type: 'REPULSE',
            name: '驳回',
            color: 'danger'
          },
          REVOCATION: {
            type: 'REVOCATION',
            name: '撤回',
            color: 'danger'
          },
          STOP_KILL: {
            type: 'STOP_KILL',
            name: '结束秒杀',
            color: 'primary'
          },
          END: {
            type: 'END',
            name: '已结束',
            color: 'primary'
          },
          DELETE: {
            type: 'DELETE',
            name: '已删除',
            color: 'danger'
          }
        },
        applyItemMap: {},
        loadingEnd: false
      }
    },
    created() {
    },
    methods: {
      open(node) {
        console.log(node)
        this.loadingEnd = false
        this.node = node
        this.titleInfo.title = this.node.nodeName
        this.itemList = node.itemList || []
        this.visibleInfo.nodeId = node.nodeId
        this.stackList.push(this.visibleInfo)
        this.visibleInfo.visible = true
        this.fetchMixFormList()
      },
      beforeClose() {
        if (this.$refs.applyFormPopup) {
          this.$refs.applyFormPopup.close()
        }
        this.$emit('close')
      },
      nodeListPop() {
        this.titleInfo.title = this.node.nodeName
        console.log('nodeListPop', this.titleInfo)
      },
      fetchMixFormList() {

        this.$store.dispatch('actionMixFormNodeList', {
          mixFormId: this.mixFormId,
          parentId: this.node.nodeId
        })
          .then(res => {
            this.nodeList = res || []

            res.forEach(node => {
              // 记录发起表单的item
              node.itemList.forEach(item => {
                if (item.itemType === MIX_FORM_ITEM_TYPE_APPLY) {
                  this.applyItemMap[item.itemDetail.instanceId] = item
                }
              })
            })
            this.fetchNodeApplyItemStatus()

          })
          .catch(console.error)
          .finally(() => {
            this.loadingEnd = true
          })
      },
      // 获取节点挂载的我发起的表单的状态
      fetchNodeApplyItemStatus() {
        if (!Object.keys(this.applyItemMap)) {
          return
        }
        this.$store.dispatch('actionFormStatus', {
          instanceIdList: Object.keys(this.applyItemMap)
        }).then(res => {
          Object.keys(res).forEach(key => {
            const item = this.applyItemMap[key]
            if (item) {
              this.$set(item.itemDetail, 'status', res[key])
            }
          })
        })
      },
      onClickNode(node) {
        this.$store.dispatch('actionMixFormNodeItemList', {
          mixFormId: this.mixFormId,
          nodeId: node.nodeId
        }).then(res => {
          node.itemList.splice(0, node.itemList.length, ...res)
          node.itemList.forEach(item => {
            if (item.itemType === MIX_FORM_ITEM_TYPE_APPLY) {
              this.applyItemMap[item.itemDetail.instanceId] = item
            }
          })
          this.fetchNodeApplyItemStatus()
        }).catch(console.error)

        if (this.$refs.nodeListPopup) {
          this.$refs.nodeListPopup.open(node)
        }
      },
      onClickItem(item) {

        if ([MIX_FORM_ITEM_TYPE_ATTACHMENT,
          MIX_FORM_ITEM_TYPE_IMAGE,
          MIX_FORM_ITEM_TYPE_MEMO].includes(item.itemType)) {
          if (this.$refs.nodeItemDetailPopup) {
            this.$refs.nodeItemDetailPopup.open({
              nodeId: this.node.nodeId,
              itemId: item.itemId
            })
          }
        } else {
          switch (item.itemType) {
            case MIX_FORM_ITEM_TYPE_DASHBOARD:
              this.$store.dispatch('actionDashboardPermission', {
                appId: item.itemDetail.appId,
                dashboardId: item.itemDetail.dashId
              }).then(res => {
                if (res.hasPer) {
                  if (this.$refs.dashboardPopup) {
                    this.$refs.dashboardPopup.open({
                      appId: item.itemDetail.appId,
                      dashboardId: item.itemDetail.dashId
                    })
                  }
                } else {
                  this.$toast.fail('您暂无权限查看')
                }
              }).catch(console.error)
              break
            case MIX_FORM_ITEM_TYPE_VIEW:
              if (item.itemDetail.viewId === FORM_VIEW_TYPE_DATA_HANDLE) {
                this.$store.dispatch('actionFormDataPermission', {
                  appId: item.itemDetail.appId,
                  formId: item.itemDetail.formId
                }).then(res => {
                  if (res.hasPer) {
                    if (this.$refs.formDataViewPopup) {
                      this.$refs.formDataViewPopup.open({
                        appId: item.itemDetail.appId,
                        formId: item.itemDetail.formId,
                        viewId: item.itemDetail.viewId
                      })
                    }
                  } else {
                    this.$toast.fail('您暂无权限查看')
                  }
                }).catch(console.error)
              } else {
                this.$store.dispatch('actionFormViewPermission', {
                  appId: item.itemDetail.appId,
                  formId: item.itemDetail.formId,
                  viewId: item.itemDetail.viewId
                }).then(res => {
                  if (res.hasPer) {
                    if (item.itemDetail.viewType === FORM_VIEW_TYPE_BOARD_VIEW) {
                      this.$toast.fail('移动端暂时无法查看看板视图，请在网页端查看')
                    } else {
                      if (this.$refs.formDataViewPopup) {
                        this.$refs.formDataViewPopup.open({
                          appId: item.itemDetail.appId,
                          formId: item.itemDetail.formId,
                          viewId: item.itemDetail.viewId
                        })
                      }
                    }
                  } else {
                    this.$toast.fail('您暂无权限查看')
                  }
                }).catch(console.error)
              }
              break
            case MIX_FORM_ITEM_TYPE_MIX_FORM:
              this.$store.dispatch('actionMixFormPermission', {
                mixFormId: item.itemDetail.mixFormId
              }).then(res => {
                if (res.hasPer) {
                  if (process.env.NODE_ENV === 'production') {
                    location.replace(`${location.origin}${this.$MINIAPP_BASE_PATH}/#/mix_form/node_list?mixFormId=${item.itemDetail.mixFormId}`)
                  } else {
                    location.replace(`http://192.168.50.35:8080/#/mix_form/node_list?mixFormId=${item.itemDetail.mixFormId}`)
                  }
                } else {
                  this.$toast.fail('您暂无权限查看')
                }
              }).catch(console.error)
              break
            case MIX_FORM_ITEM_TYPE_DATA:

              if (item.itemDetail.viewId !== FORM_VIEW_TYPE_DATA_HANDLE) {
                this.$store.dispatch('actionFormViewPermission', {
                  appId: item.itemDetail.appId,
                  formId: item.itemDetail.formId,
                  viewId: item.itemDetail.viewId
                }).then(res => {
                  if (res.hasPer) {

                    if (this.$refs.applyFormDetail) {
                      this.$refs.applyFormDetail.open({
                        nodeId: this.node.nodeId,
                        itemId: item.itemId
                      })
                    }
                  } else {
                    this.$toast.fail('您暂无权限查看')
                    return null
                  }
                }).catch(console.error)
              } else {
                this.$store.dispatch('actionFormDataPermission', {
                  appId: item.itemDetail.appId,
                  formId: item.itemDetail.formId
                }).then(res => {
                  if (res.hasPer) {
                    if (this.$refs.applyFormDetail) {
                      this.$refs.applyFormDetail.open({
                        nodeId: this.node.nodeId,
                        itemId: item.itemId
                      })
                    }
                  } else {
                    this.$toast.fail('您暂无权限查看')
                  }
                }).catch(console.error)
              }
              break
            case MIX_FORM_ITEM_TYPE_APPLY:
              // 1.判断是否是自己处理的流程
              this.$store.dispatch('actionFormApplyViewCheck', {
                instanceId: item.itemDetail.instanceId
              }).then(res => {
                if (res) {
                  if (this.$refs.handleFormPopup) {
                    this.$refs.handleFormPopup.open({
                      appId: item.itemDetail.appId,
                      formId: item.itemDetail.formId,
                      instanceId: item.itemDetail.instanceId,
                      stepId: res.stepId,
                    })
                  }
                } else {
                  // 不是自己的流程 || 是自己的流程并且流程结束（默认返回有权限）
                  // 2、判断权限，有权限，就进入到数据详情
                  this.$store.dispatch('actionFormApplyDetailPermission', {
                    appId: item.itemDetail.appId,
                    formId: item.itemDetail.formId,
                    instanceId: item.itemDetail.instanceId
                  }).then(res => {
                    if (res.hasPer) {
                      if (this.$refs.applyFormDetail) {
                        this.$refs.applyFormDetail.open({
                          nodeId: this.node.nodeId,
                          itemId: item.itemId
                        })
                      }
                    } else {
                      this.$toast.fail('您暂无权限查看')
                    }
                  })
                }
              }).catch(console.error)
              break
          }
        }
      },

      // 点击node详情
      onClickNodeDetail() {
        if (this.$refs.nodeDetailPopup) {
          this.$refs.nodeDetailPopup.open(this.node.nodeId)
        }
      },
      onClickEditNode() {
        if (this.mixFormInfo.archived) {
          this.$toast.fail(`该${this.$store.getters.mix_form_name}已归档，暂时无法操作，请启用后操作`)
          return
        }
        if (this.$refs.nodeAddPopup) {
          this.$refs.nodeAddPopup.open({
            nodeId: this.node.nodeId
          })
        }
      },

      onClickDeleteNode() {
        if (this.mixFormInfo.archived) {
          this.$toast.fail(`该${this.$store.getters.mix_form_name}已归档，暂时无法操作，请启用后操作`)
          return
        }
        this.$dialog.confirm({
          title:'提示',
          message: '删除数据后将无法恢复，是否删除？',
          confirmButtonText: '删除',
          cancelButtonText: '取消'
        }).then(() => {
          this.$store.dispatch('actionMixFormNodeDelete', {
            mixFormId: this.mixFormId,
            nodeId: this.node.nodeId
          }).then(res => {
            this.$toast.success('删除成功')
            this.$emit('deleteNodeComplete', this.node.nodeId)
            const visibleInfo = this.stackList.pop()
            visibleInfo.visible = false
          }).catch(console.error)
        }).catch(action => {
        })
      },

      // 添加item
      onClickAddItem() {
        if (this.mixFormInfo.archived) {
          this.$toast.fail(`该${this.$store.getters.mix_form_name}已归档，暂时无法操作，请启用后操作`)
          return
        }
        if (this.$refs.selectItemPopup) {
          this.$refs.selectItemPopup.open()
        }
      },
      // 删除item
      deleteItem(item) {
        if (this.mixFormInfo.archived) {
          this.$toast.fail(`该${this.$store.getters.mix_form_name}已归档，暂时无法操作，请启用后操作`)
          return
        }
        this.$dialog.confirm({
          title:'提示',
          message: '将会删除关联入口，但不会删除数据。是否删除？',
          confirmButtonText: '删除',
          cancelButtonText: '取消'
        }).then(() => {
          this.$store.dispatch('actionMixFormNodeItemDelete', {
            mixFormId: this.mixFormId,
            nodeId: this.node.nodeId,
            itemId: item.itemId,
          }).then(res => {
            this.$toast.success('删除成功')
            this.deleteNodeItemComplete(item.itemId)
          }).catch(console.error)

        }).catch(action => {
        })
      },
      // 编辑item
      editItem(item) {
        if (this.mixFormInfo.archived) {
          this.$toast.fail(`该${this.$store.getters.mix_form_name}已归档，暂时无法操作，请启用后操作`)
          return
        }
        switch (item.type) {
          case MIX_FORM_ITEM_TYPE_ATTACHMENT:
            if (this.$refs.nodeAddAttachPopup) {
              this.$refs.nodeAddAttachPopup.open(item)
            }
            break
          case MIX_FORM_ITEM_TYPE_IMAGE:
            if (this.$refs.nodeAddAttachPopup) {
              this.$refs.nodeAddAttachPopup.open(item)
            }
            break
          case MIX_FORM_ITEM_TYPE_MEMO:
            if (this.$refs.nodeAddAttachPopup) {
              this.$refs.nodeAddAttachPopup.open(item)
            }
            break
          default:
            break
        }
      },
      // 选择完成
      selectCreateItem(item) {

        const info = {
          mixFormId: this.mixFormId,
          nodeId: this.node.nodeId,
          itemType: item.type,
          itemImage: item.icon,
          sortIndex: 1,
          userId: this.$store.getters.userId,
          itemDetail: {
            name: ''
          }, //挂载的详情信息,后端不解析 前端请在下面补全结构信息
        }
        switch (item.type) {
          case MIX_FORM_ITEM_TYPE_NODE:
            if (this.$refs.nodeAddPopup) {
              this.$refs.nodeAddPopup.open({
                parentId: this.node.nodeId
              })
            }
            break
          case MIX_FORM_ITEM_TYPE_ATTACHMENT:
            info.itemDetail.fileList = []
            info.itemDetail.remark = ''
            if (this.$refs.nodeAddAttachPopup) {
              this.$refs.nodeAddAttachPopup.open(info)
            }
            break
          case MIX_FORM_ITEM_TYPE_IMAGE:
            info.itemDetail.fileList = []
            info.itemDetail.remark = ''
            if (this.$refs.nodeAddAttachPopup) {
              this.$refs.nodeAddAttachPopup.open(info)
            }
            break
          case MIX_FORM_ITEM_TYPE_MEMO:
            info.itemDetail.fileList = []
            if (this.$refs.nodeAddAttachPopup) {
              this.$refs.nodeAddAttachPopup.open(info)
            }
            break
          case MIX_FORM_ITEM_TYPE_APPLY:
            if (this.$refs.applyFormPopup) {
              this.$refs.applyFormPopup.open()
            }
            break
          case MIX_FORM_ITEM_TYPE_VIEW:
            info.itemDetail.appId = ''
            info.itemDetail.formId = ''
            info.itemDetail.viewId = ''
            info.itemDetail.viewType = ''
            break
          case MIX_FORM_ITEM_TYPE_DASHBOARD:
            info.itemDetail.appId = ''
            info.itemDetail.dashId = ''
            break
          case MIX_FORM_ITEM_TYPE_MIX_FORM:
            info.itemDetail.mixFormId = ''
            break
          case MIX_FORM_ITEM_TYPE_DATA:
            info.itemDetail.appId = ''
            info.itemDetail.formId = ''
            info.itemDetail.viewId = ''
            info.itemDetail.instanceId = ''
            break
          default:
            break
        }
      },

      // 更新下级目录完成
      updateNodeSuccess(node) {
        Object.keys(node).forEach(key => {
          if (this.node.hasOwnProperty(key)) {
            this.node[key] = node[key]
          }
        })
      },
      // 创建下级目录成功
      createNodeSuccess(node) {
        this.fetchMixFormList()
      },

      // 更新item完成
      updateItemComplete(itemInfo) {
        this.itemList.forEach(item => {
          if (item.itemId === itemInfo.itemId) {
            Object.keys(itemInfo).forEach(key => {
              if (item.hasOwnProperty(key)) {
                item[key] = itemInfo[key]
              }
            })
          }
        })
      },
      // 删除item完成
      deleteNodeItemComplete(itemId) {
        const item = this.itemList.filter(item => item.itemId === itemId)[0]
        if (item) arrayRemove(this.itemList, item)
      },
      // 创建item完成
      createItemComplete(itemInfo) {
        this.itemList.push(itemInfo)
      },
      // 发起表单完成
      applyFormComplete(data) {
        const info = {
          userId: this.$store.state.userInfo.userId,
          mixFormId: this.mixFormId,
          nodeId: this.node.nodeId,
          itemType: MIX_FORM_ITEM_TYPE_APPLY,
          itemImage: `${this.$BASE_PATH}/fetch/image?id=385822473121169409.png`,
          sortIndex: 1,
          itemDetail: {
            name: data.title,
            ...data
          }, //挂载的详情信息,后端不解析 前端请在下面补全结构信息
        }
        this.$store.dispatch('actionMixFormNodeItemAdd', {
          ...info
        }).then(res => {
          info.itemId = res.itemId
          this.itemList.push(info)
          this.applyItemMap[info.itemDetail.instanceId] = info
          this.fetchNodeApplyItemStatus()
        }).catch(console.error)
      },

      // 子目录被删除
      deleteNodeComplete(nodeId) {
        const node = this.nodeList.filter(node => node.nodeId === nodeId)[0]
        if (node) arrayRemove(this.nodeList, node)
      },

      // 处理表单完成
      handleComplete() {
        this.fetchNodeApplyItemStatus()
      }
    }
  }
</script>

<style lang="less">

  .node-list-popup {
    background-color: #F6F6F6 !important;

    .header {
      height: 60px;
      display: flex;
      align-items: center;
      padding: 0 10px;
      background-color: #fff;
      border-bottom: 1px solid #e6e6e6;

      > .iconfont {
        font-size: 18px;
        width: 24px;
        margin-left: 5px;
      }

      .info {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        border-left: 1px solid #e6e6e6;
        padding-left: 10px;
        height: 100%;
        margin: 0 5px;

        .name {
          color: #333333;
          font-size: 14px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-wrap: break-word;
        }

        .detail {
          font-size: 12px;
          color: #3a8ee6;
          display: flex;
          margin-top: 5px;

          > div {
            margin-right: 10px;
            width: 30px;
            height: 20px;
            line-height: 20px;
          }

          .delete-button {
            color: red;
          }
        }
      }

      .van-icon {
        width: 24px;
        font-size: 20px;
      }
    }

    .content {
      padding-top: 10px;
      position: relative;

      .node-item {
        position: relative;
        margin: 0 10px 10px 40px;
        height: 50px;
        display: flex;
        align-items: center;
        padding-right: 10px;
        background-color: #fff;

        .color {
          width: 5px;
          height: 100%;
          margin-right: 10px;
        }

        .node-name {
          flex: 1;
          color: #333333;
          font-size: 14px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-wrap: break-word;
        }

        .van-icon {
          font-size: 16px;
          width: 20px;
        }

        &:before {
          width: 20px;
          height: 0;
          border-top: 1px dashed #bbb;
          position: absolute;
          left: -22px;
          top: 25px;
          content: "";
          display: block;
        }
      }

      &:after {
        width: 0;
        border-left: 1px dashed #bbb;
        position: absolute;
        left: 18px;
        bottom: 25px;
        top: 5px;
        content: "";
        display: block;
      }
    }

    .item {
      position: relative;
      margin: 0 10px 10px 40px;
      height: 50px;
      display: flex;
      align-items: center;
      padding: 0 10px;
      background-color: #fff;
      box-shadow: 0 1px 10px rgba(31, 35, 41, 0.08);

      img {
        width: 30px;
        height: 30px;
        object-fit: cover;
        margin-right: 10px;
        border-radius: 4px;
      }

      .info {
        width: calc(100% - 30px);
        text-align: left;

        .top {
          display: flex;
          align-items: center;

          .name {
            flex: 1;
            color: #333333;
            margin-bottom: 5px;
            font-size: 12px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-wrap: break-word;
          }
        }

        .bottom {
          width: 100%;
          display: flex;
          justify-content: space-between;

          .user {
            width: calc(100% - 60px);
            color: #909399;
            font-size: 12px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-wrap: break-word;
          }

          .handle {

            .el-button {
              padding: 0;
              margin: 0 10px 0 0;
            }
          }
        }

      }

      &:before {
        width: 20px;
        height: 0;
        border-top: 1px dashed #bbb;
        position: absolute;
        left: -22px;
        top: 25px;
        content: "";
        display: block;
      }
    }

    .node-detail-popup {
      background-color: #F6F6F6;
    }
  }
</style>